import React from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import InputGroupShape from "../../../../../../../../components/Inputs/InputGroupShape";
import Input from "../../../../../../../../components/Inputs/Input";

const inputs = [
  {
    key: "sheet Size",
    name: "sheetSize",
    options: [" "],
    isRequired: false,
  },
  {
    key: "sheet Orientation",
    name: "sheetOrientation",
    options: [" "],
    isRequired: false,
  },
  {
    key: "Drawing Num.",
    name: "drawingNum",
    isRequired: true,
  },
  {
    key: "Title",
    name: "title",
    isRequired: true,
  },
];
export default function Modeling2DPanel() {
  return (
    <Box sx={{ width: 900 }}>
      <InputGroupShape>
        <Grid container>
          {inputs.map((input) => (
            <Grid xs={6} sx={{ my: 0.5 }}>
              <Grid container>
                <Grid
                  item
                  xs={4}
                  sx={{
                    py: 0.5,
                    pr: !input.isRequired && 2,
                  }}
                >
                  {input.key}:
                  {input.isRequired && (
                    <span
                      style={{
                        float: "right",
                        color: "red",
                        fontSize: "18px",
                        padding: "0 5px",
                        lineHeight: 1.1,
                      }}
                    >
                      *
                    </span>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <Input input={input} inputPadding={0.5} />
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </InputGroupShape>

      <InputGroupShape>
        <Grid container>
          <Grid xs={6} sx={{ display: "flex", alignItems: "center" }}>
            <FormControl>
              <RadioGroup name="2D">
                <FormControlLabel
                  value="Top"
                  control={<Radio />}
                  label="Female"
                />
                <FormControlLabel
                  value="Side"
                  control={<Radio />}
                  label="Male"
                />
                <FormControlLabel
                  value="Front"
                  control={<Radio />}
                  label="Other"
                />
              </RadioGroup>
            </FormControl>
            <Button variant="outlined">2D Drawing</Button>
          </Grid>
          <Grid xs={6}>
            <FormControl sx={{ width: "50%" }}>
              <Select
                labelId="input-label"
                id="input"
                sx={{ "& div": { p: 1 } }}
              >
                {[" "].map((opt) => {
                  return (
                    <MenuItem value={opt} key={opt}>
                      {opt}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <Box>
              <Button variant="outlined" sx={{ mx: 8, mt: 1 }}>
                Subview
              </Button>
            </Box>
          </Grid>
        </Grid>
      </InputGroupShape>

      <Grid container>
        <Grid xs={8}>
          <InputGroupShape>
            <Grid container>
              <Grid item xs={6} sx={{ pr: 1 }}>
                <Button variant="outlined" fullWidth sx={{ my: 1 }}>
                  Revision Table
                </Button>
                <Button variant="outlined" fullWidth sx={{ my: 1 }}>
                  Notes
                </Button>
                <Button variant="outlined" fullWidth sx={{ my: 1 }}>
                  Nozzles Schedule
                </Button>
              </Grid>
              <Grid item xs={6} sx={{ pl: 1 }}>
                <Button variant="outlined" fullWidth sx={{ my: 1 }}>
                  PartsList
                </Button>
                <Button variant="outlined" fullWidth sx={{ my: 1 }}>
                  Design Data
                </Button>
                <Button variant="outlined" fullWidth sx={{ my: 1 }}>
                  Weld Detail
                </Button>
              </Grid>
            </Grid>
          </InputGroupShape>
        </Grid>
        <Grid xs={4}>
          <InputGroupShape>
            <Button variant="outlined" fullWidth sx={{ my: 1 }}>
              Hide From View
            </Button>
            <FormControl fullWidth sx={{ my: 1 }}>
              <Select
                labelId="input-label"
                id="input"
                sx={{ "& div": { p: 1 } }}
              >
                {[" "].map((opt) => {
                  return (
                    <MenuItem value={opt} key={opt}>
                      {opt}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <Button variant="outlined" fullWidth sx={{ my: 1 }}>
              Hide From PartsList
            </Button>
            <TextField sx={{ "& input": { p: 1 }, my: 1 }} fullWidth disabled />
            <Button variant="outlined" fullWidth sx={{ my: 1 }}>
              Send BOM to web
            </Button>
          </InputGroupShape>
        </Grid>
      </Grid>
    </Box>
  );
}
